// src/i18n/locales/th.js

export default {
  countries: {
    'AF': 'อัฟกานิสถาน',
    'AL': 'แอลเบเนีย',
    'DZ': 'แอลจีเรีย',
    'AD': 'อันดอร์รา',
    'AO': 'แองโกลา',
    'AG': 'แอนติกาและบาร์บูดา',
    'AR': 'อาร์เจนตินา',
    'AM': 'อาร์เมเนีย',
    'AU': 'ออสเตรเลีย',
    'AT': 'ออสเตรีย',
    'AZ': 'อาเซอร์ไบจาน',
    'BS': 'บาฮามาส',
    'BH': 'บาห์เรน',
    'BD': 'บังกลาเทศ',
    'BB': 'บาร์เบโดส',
    'BY': 'เบลารุส',
    'BE': 'เบลเยียม',
    'BZ': 'เบลีซ',
    'BJ': 'เบนิน',
    'BT': 'ภูฏาน',
    'BO': 'โบลิเวีย',
    'BA': 'บอสเนียและเฮอร์เซโกวีนา',
    'BW': 'บอตสวานา',
    'BR': 'บราซิล',
    'BN': 'บรูไน',
    'BG': 'บัลแกเรีย',
    'BF': 'บูร์กินาฟาโซ',
    'BI': 'บุรุนดี',
    'CV': 'กาบูเวร์ดี',
    'KH': 'กัมพูชา',
    'CM': 'แคเมรูน',
    'CA': 'แคนาดา',
    'CF': 'สาธารณรัฐแอฟริกากลาง',
    'TD': 'ชาด',
    'CL': 'ชิลี',
    'CN': 'จีน',
    'CO': 'โคลอมเบีย',
    'KM': 'คอโมโรส',
    'CG': 'คองโก',
    'CD': 'คองโก สาธารณรัฐประชาธิปไตย',
    'CR': 'คอสตาริกา',
    'CI': 'โกตดิวัวร์',
    'HR': 'โครเอเชีย',
    'CU': 'คิวบา',
    'CY': 'ไซปรัส',
    'CZ': 'เช็กเกีย',
    'DK': 'เดนมาร์ก',
    'DJ': 'จิบูตี',
    'DM': 'โดมินิกา',
    'DO': 'สาธารณรัฐโดมินิกัน',
    'EC': 'เอกวาดอร์',
    'EG': 'อียิปต์',
    'SV': 'เอลซัลวาดอร์',
    'GQ': 'อิเควทอเรียลกินี',
    'ER': 'เอริเทรีย',
    'EE': 'เอสโตเนีย',
    'ET': 'เอธิโอเปีย',
    'FJ': 'ฟิจิ',
    'FI': 'ฟินแลนด์',
    'FR': 'ฝรั่งเศส',
    'GA': 'กาบอง',
    'GM': 'แกมเบีย',
    'GE': 'จอร์เจีย',
    'DE': 'เยอรมนี',
    'GH': 'กานา',
    'GR': 'กรีซ',
    'GD': 'เกรนาดา',
    'GT': 'กัวเตมาลา',
    'GN': 'กินี',
    'GW': 'กินี-บิสเซา',
    'GY': 'กายอานา',
    'HT': 'เฮติ',
    'HN': 'ฮอนดูรัส',
    'HU': 'ฮังการี',
    'IS': 'ไอซ์แลนด์',
    'IN': 'อินเดีย',
    'ID': 'อินโดนีเซีย',
    'IR': 'อิหร่าน',
    'IQ': 'อิรัก',
    'IE': 'ไอร์แลนด์',
    'IL': 'อิสราเอล',
    'IT': 'อิตาลี',
    'JM': 'จาเมกา',
    'JP': 'ญี่ปุ่น',
    'JO': 'จอร์แดน',
    'KZ': 'คาซัคสถาน',
    'KE': 'เคนยา',
    'KI': 'คิริบาส',
    'KP': 'เกาหลีเหนือ',
    'KR': 'เกาหลีใต้',
    'KW': 'คูเวต',
    'KG': 'คีร์กีซสถาน',
    'LA': 'ลาว',
    'LV': 'ลัตเวีย',
    'LB': 'เลบานอน',
    'LS': 'เลโซโท',
    'LR': 'ไลบีเรีย',
    'LY': 'ลิเบีย',
    'LI': 'ลิกเตนสไตน์',
    'LT': 'ลิทัวเนีย',
    'LU': 'ลักเซมเบิร์ก',
    'MG': 'มาดากัสการ์',
    'MW': 'มาลาวี',
    'MY': 'มาเลเซีย',
    'MV': 'มัลดีฟส์',
    'ML': 'มาลี',
    'MT': 'มอลตา',
    'MH': 'หมู่เกาะมาร์แชลล์',
    'MR': 'มอริเตเนีย',
    'MU': 'มอริเชียส',
    'MX': 'เม็กซิโก',
    'FM': 'ไมโครนีเซีย',
    'MD': 'มอลโดวา',
    'MC': 'โมนาโก',
    'MN': 'มองโกเลีย',
    'ME': 'มอนเตเนโกร',
    'MA': 'โมร็อกโก',
    'MZ': 'โมซัมบิก',
    'MM': 'พม่า',
    'NA': 'นามิเบีย',
    'NR': 'นาอูรู',
    'NP': 'เนปาล',
    'NL': 'เนเธอร์แลนด์',
    'NZ': 'นิวซีแลนด์',
    'NI': 'นิการากัว',
    'NE': 'ไนเจอร์',
    'NG': 'ไนจีเรีย',
    'MK': 'มาซิโดเนียเหนือ',
    'NO': 'นอร์เวย์',
    'OM': 'โอมาน',
    'PK': 'ปากีสถาน',
    'PW': 'ปาเลา',
    'PS': 'ปาเลสไตน์ รัฐ',
    'PA': 'ปานามา',
    'PG': 'ปาปัวนิวกินี',
    'PY': 'ปารากวัย',
    'PE': 'เปรู',
    'PH': 'ฟิลิปปินส์',
    'PL': 'โปแลนด์',
    'PT': 'โปรตุเกส',
    'QA': 'กาตาร์',
    'RO': 'โรมาเนีย',
    'RU': 'รัสเซีย',
    'RW': 'รวันดา',
    'KN': 'เซนต์คิตส์และเนวิส',
    'LC': 'เซนต์ลูเซีย',
    'VC': 'เซนต์วินเซนต์และเกรนาดีนส์',
    'WS': 'ซามัว',
    'SM': 'ซานมารีโน',
    'ST': 'เซาตูเมและปรินซีปี',
    'SA': 'ซาอุดีอาระเบีย',
    'SN': 'เซเนกัล',
    'RS': 'เซอร์เบีย',
    'SC': 'เซเชลส์',
    'SL': 'เซียร์ราลีโอน',
    'SG': 'สิงคโปร์',
    'SK': 'สโลวาเกีย',
    'SI': 'สโลวีเนีย',
    'SB': 'หมู่เกาะโซโลมอน',
    'SO': 'โซมาเลีย',
    'ZA': 'แอฟริกาใต้',
    'SS': 'ซูดานใต้',
    'ES': 'สเปน',
    'LK': 'ศรีลังกา',
    'SD': 'ซูดาน',
    'SR': 'ซูรินาเม',
    'SZ': 'เอสวาตีนี',
    'SE': 'สวีเดน',
    'CH': 'สวิตเซอร์แลนด์',
    'SY': 'ซีเรีย',
    'TJ': 'ทาจิกิสถาน',
    'TZ': 'แทนซาเนีย',
    'TH': 'ไทย',
    'TL': 'ติมอร์-เลสเต',
    'TG': 'โตโก',
    'TO': 'ตองกา',
    'TT': 'ตรินิแดดและโตเบโก',
    'TN': 'ตูนิเซีย',
    'TR': 'ตุรกี',
    'TM': 'เติร์กเมนิสถาน',
    'TV': 'ตูวาลู',
    'UG': 'ยูกันดา',
    'UA': 'ยูเครน',
    'AE': 'สหรัฐอาหรับเอมิเรตส์',
    'GB': 'สหราชอาณาจักร',
    'US': 'สหรัฐอเมริกา',
    'UY': 'อุรุกวัย',
    'UZ': 'อุซเบกิสถาน',
    'VU': 'วานูอาตู',
    'VA': 'นครรัฐวาติกัน',
    'VE': 'เวเนซุเอลา',
    'VN': 'เวียดนาม',
    'YE': 'เยเมน',
    'ZM': 'แซมเบีย',
    'ZW': 'ซิมบับเว'
  },
  verification: {
    verifying: 'กำลังตรวจสอบอีเมลของคุณ...',
    success: 'ตรวจสอบอีเมลสำเร็จ!',
    failed: 'การตรวจสอบล้มเหลว',
    accountVerified: 'บัญชีของคุณได้รับการตรวจสอบเรียบร้อยแล้ว คุณสามารถเข้าสู่ระบบบัญชีของคุณได้แล้ว',
    invalidLink: 'ลิงก์ตรวจสอบไม่ถูกต้องหรือหมดอายุ',
    missingToken: 'ขาดโทเค็นการตรวจสอบ',
    generalError: 'เกิดข้อผิดพลาดระหว่างการตรวจสอบ โปรดลองอีกครั้งในภายหลัง',
    proceedToLogin: 'ดำเนินการเข้าสู่ระบบ',
    backToLogin: 'กลับไปเข้าสู่ระบบ'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'แดชบอร์ด',
    system: 'ระบบ',
    settings: 'การตั้งค่า',
    overview: 'ภาพรวม',
    database: 'ฐานข้อมูล',
    logs: 'บันทึก',
    userManagement: 'การจัดการผู้ใช้',
    security: 'ความปลอดภัย',
    systemAdministration: 'การบริหารระบบ',
    loading: 'กำลังโหลด...',
    close: 'ปิดแดชบอร์ด',
    edit: 'แก้ไข',
    systemUptime: 'เวลาทำงานของระบบ',
    avgResponseTime: 'เวลาตอบสนองเฉลี่ย',
    errorRate: 'อัตราข้อผิดพลาด',
    activeUsers: 'ผู้ใช้ที่ใช้งานอยู่',
    monthlyActiveUsers: 'ผู้ใช้ที่ใช้งานรายเดือน (MAU)',
    fromLastMonth: 'จากเดือนที่แล้ว',
    today: 'วันนี้',
    // --- UPDATED TABS ---
    tabs: {
      overview: 'สุขภาพระบบ',
      hierarchy: 'ลำดับชั้นความรู้', // NEW
      documents: 'การจัดการเอกสาร', // NEW
      database: 'ฐานข้อมูล',
      logs: 'บันทึก',
      security: 'ความปลอดภัย',
      users: 'ผู้ใช้'
    },
    // --- NEW KEYS ---
    contentManagement: "การจัดการเนื้อหา",
    knowledgeHierarchy: "ลำดับชั้นความรู้",
    documentManagement: "การจัดการเอกสาร",
    noLogsFound: "ไม่พบบันทึกสำหรับวันนี้",
    invalidLogsResponse: "โครงสร้างการตอบสนองสรุปบันทึกไม่ถูกต้อง",
    logsSummaryError: "ล้มเหลวในการโหลดสรุปบันทึก",
    buttons: {
      save: "บันทึก",
      cancel: "ยกเลิก",
      switch: "สลับอยู่ดี",
      discard: "ยกเลิก"
    },
    confirm: {
      defaultTitle: "ยืนยัน",
      defaultMessage: "คุณแน่ใจหรือไม่?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'สถานะสุขภาพระบบ',
    runDiagnostics: 'รันการวินิจฉัย',
    resourceUsage: 'การใช้งานทรัพยากร',
    services: {
      apiServices: 'บริการ API',
      database: 'ฐานข้อมูล',
      cache: 'แคช',
      storage: 'พื้นที่เก็บข้อมูล',
      messageQueue: 'คิวข้อความ',
      externalApi: 'API ภายนอก'
    },
    resources: {
      cpu: 'การใช้งาน CPU',
      memory: 'การใช้งานหน่วยความจำ',
      storage: 'การใช้งานพื้นที่เก็บข้อมูล',
      network: 'แบนด์วิดธ์เครือข่าย'
    },
    databaseManagement: 'การจัดการฐานข้อมูล',
    reindexDatabase: 'รีอินเด็กซ์ฐานข้อมูล',
    lastReindex: 'รีอินเด็กซ์ล่าสุด',
    databaseSize: 'ขนาดฐานข้อมูล',
    totalTables: 'ตารางทั้งหมด',
    logManagement: 'การจัดการบันทึก',
    rolloverLogs: 'โรลโอเวอร์บันทึก',
    searchLogs: 'ค้นหาบันทึก',
    logTime: 'เวลา',
    logLevel: 'ระดับ',
    logService: 'บริการ',
    logMessage: 'ข้อความ',
    showingEntries: 'แสดง {start}-{end} จาก {total} รายการ',
    logLevels: {
      error: 'ข้อผิดพลาด',
      warn: 'เตือน',
      info: 'ข้อมูล',
      debug: 'ดีบัก'
    },
    logMessages: {
      connectionTimeout: 'หมดเวลาการเชื่อมต่อกับผู้ให้บริการภายนอก',
      lowDiskSpace: 'พื้นที่ดิสก์ต่ำกว่าเกณฑ์ 10%',
      userRoleUpdated: 'อัปเดตบทบาทผู้ใช้สำหรับ admin@huduma.ai'
    },
    userName: 'ชื่อ',
    userEmail: 'อีเมล',
    userRole: 'บทบาท',
    userStatus: 'สถานะ',
    userActions: 'การกระทำ',
    roleAdministrator: 'ผู้ดูแลระบบ',
    roleUser: 'ผู้ใช้',
    statusActive: 'ใช้งาน',
    dbActions: {
      reindex: 'รีอินเด็กซ์',
      backup: 'สำรองข้อมูล',
      optimize: 'ปรับปรุง',
      reindexDesc: 'สร้างดัชนีฐานข้อมูลใหม่',
      backupDesc: 'สร้างสำรองฐานข้อมูล',
      optimizeDesc: 'ปรับปรุงประสิทธิภาพการสอบถาม'
    },
    operations: {
      reindexTitle: 'ผลลัพธ์การรีอินเด็กซ์ฐานข้อมูล',
      backupTitle: 'ผลลัพธ์การสำรองฐานข้อมูล',
      optimizeTitle: 'ผลลัพธ์การปรับปรุงฐานข้อมูล',
      reindexResults: 'ผลลัพธ์รีอินเด็กซ์',
      optimizeResults: 'ผลลัพธ์การปรับปรุง',
      collection: 'คอลเลกชัน',
      status: 'สถานะ',
      indexSuggestions: 'ข้อเสนอแนะดัชนี',
      backupDetails: 'รายละเอียดสำรอง',
      backupFile: 'ไฟล์สำรอง',
      backupLocation: 'ตำแหน่ง',
      backupSize: 'ขนาด',
      errorDetails: 'รายละเอียดข้อผิดพลาด',
      close: 'ปิด',
      resultsTitle: 'ผลลัพธ์การดำเนินการ',
      reindexDatabase: {
        success: 'รีอินเด็กซ์ฐานข้อมูลเสร็จสิ้นสำเร็จ',
        error: 'ข้อผิดพลาดระหว่างรีอินเด็กซ์ฐานข้อมูล',
        loading: 'กำลังรีอินเด็กซ์ฐานข้อมูล...'
      },
      backupDatabase: {
        success: 'สำรองฐานข้อมูลเสร็จสิ้นสำเร็จ',
        error: 'ข้อผิดพลาดระหว่างสำรองฐานข้อมูล',
        loading: 'กำลังสำรองฐานข้อมูล...'
      },
      optimizeDatabase: {
        success: 'ปรับปรุงฐานข้อมูลเสร็จสิ้นสำเร็จ',
        error: 'ข้อผิดพลาดระหว่างปรับปรุงฐานข้อมูล',
        loading: 'กำลังปรับปรุงฐานข้อมูล...'
      },
      rolloverLogs: {
        success: 'โรลโอเวอร์บันทึกเสร็จสิ้นสำเร็จ',
        loading: 'กำลังโรลโอเวอร์บันทึก...'
      },
      searchLogs: {
        success: 'ค้นหาบันทึกเสร็จสิ้น',
        loading: 'กำลังค้นหาบันทึก...'
      },
      runDiagnostics: {
        success: 'การวินิจฉัยเสร็จสิ้นสำเร็จ',
        loading: 'กำลังรันการวินิจฉัย...'
      },
      runSecurityScan: {
        success: 'สแกนความปลอดภัยเสร็จสิ้นสำเร็จ',
        loading: 'กำลังรันสแกนความปลอดภัย...'
      },
      cancel: 'ยกเลิก',
      save: 'บันทึกการเปลี่ยนแปลง'
    },
    userManagementSection: {
      totalUsers: 'ผู้ใช้ทั้งหมด',
      newUsers: 'ผู้ใช้ใหม่ (เดือน)',
      searchUsers: 'ค้นหาผู้ใช้...',
      clearSearch: 'ล้างการค้นหา',
      search: 'ค้นหา',
      usersFound: 'ผู้ใช้ที่พบ',
      showAllUsers: 'แสดงผู้ใช้ทั้งหมด',
      searching: 'กำลังค้นหา...',
      searchingUsers: 'กำลังค้นหาผู้ใช้...',
      noUsersFound: 'ไม่พบผู้ใช้ที่ตรงกับเกณฑ์การค้นหาของคุณ',
      noUsers: 'ไม่มีผู้ใช้ที่มีอยู่',
      showing: 'แสดง',
      of: 'จาก',
      previous: 'ก่อนหน้า',
      next: 'ถัดไป',
      searchFields: {
        all: 'ทุกรายการ',
        name: 'ชื่อ',
        email: 'อีเมล',
        role: 'บทบาท'
      },
      userSearch: {
        resultsFound: 'พบ {total} ผู้ใช้ที่ตรงกับ "{term}"',
        error: 'ข้อผิดพลาดในการค้นหาผู้ใช้'
      }
    },
    logsSection: {
      errorLogs: 'บันทึกข้อผิดพลาด',
      warningLogs: 'บันทึกเตือน',
      noErrorLogs: 'ไม่มีบันทึกข้อผิดพลาดที่บันทึกวันนี้',
      noWarningLogs: 'ไม่มีบันทึกเตือนที่บันทึกวันนี้',
      infoLogsNote: 'บันทึกข้อมูลไม่แสดงในสรุป ใช้ฟังก์ชันค้นหาเพื่อดูบันทึกทุกประเภท',
      searchResults: 'ผลการค้นหาล่าสุด',
      entriesFound: 'รายการที่พบ',
      viewAllResults: 'ดูผลลัพธ์ทั้งหมด',
      logType: 'ประเภท',
      logCount: 'จำนวน',
      logTypes: {
        connectionTimeout: 'หมดเวลาการเชื่อมต่อ',
        databaseFailed: 'สอบถามฐานข้อมูลล้มเหลว',
        authFailed: 'การตรวจสอบสิทธิ์ล้มเหลว',
        lowDiskSpace: 'พื้นที่ดิสก์ต่ำกว่าเกณฑ์',
        slowQuery: 'ประสิทธิภาพการสอบถามช้า',
        rateLimit: 'ใกล้ถึงขีดจำกัดอัตรา'
      },
      logSearch: {
        noResultsFound: 'ไม่มีบันทึกที่ตรงกับเกณฑ์การค้นหาของคุณ',
        resultsFound: 'พบ {count} รายการบันทึก'
      }
    },
    security: {
      title: 'การตรวจสอบความปลอดภัย',
      securityScan: 'สแกนความปลอดภัย',
      runningSecurityScan: 'กำลังรันสแกน...',
      lastSecurityScan: 'สแกนความปลอดภัยล่าสุด',
      vulnerabilitiesFound: 'ช่องโหว่ที่พบ',
      daysAgo: 'วันที่ผ่านมา',
      critical: 'วิกฤติ',
      medium: 'ปานกลาง',
      low: 'ต่ำ',
      failedLoginAttempts: 'การเข้าสู่ระบบล้มเหลว (24 ชม.)',
      suspiciousActivities: 'กิจกรรมที่น่าสงสัย (24 ชม.)',
      securityRecommendations: 'ข้อเสนอแนะความปลอดภัย',
      criticalVulnerabilities: 'ช่องโหว่วิกฤติ',
      mediumVulnerabilities: 'ช่องโหว่ปานกลาง',
      lowVulnerabilities: 'ช่องโหว่ต่ำ',
      authenticationIssues: 'ปัญหาการตรวจสอบสิทธิ์',
      suspiciousActivityLogs: 'บันทึกกิจกรรมที่น่าสงสัย',
      securityProbeAttempts: 'ตรวจพบการพยายามสอดแนมความปลอดภัย',
      sensitiveFileAccess: 'ตรวจพบการพยายามเข้าถึงไฟล์หรือจุดสิ้นสุดที่ละเอียดอ่อน',
      envFileAccess: 'การพยายามเข้าถึงไฟล์สภาพแวดล้อม',
      envFileAccessDesc: 'ตรวจพบการพยายามเข้าถึงไฟล์ .env',
      gitRepoAccess: 'การพยายามเข้าถึงที่เก็บ Git',
      gitRepoAccessDesc: 'ตรวจพบการพยายามเข้าถึงไฟล์ที่เก็บ Git',
      recommendedAction: 'การกระทำที่แนะนำ',
      rateLimitRecommendation: 'พิจารณาการนำขีดจำกัดอัตรา, การบล็อก IP สำหรับผู้กระทำผิดซ้ำ และตรวจสอบให้แน่ใจว่ามีการแข็งตัวของเซิร์ฟเวอร์ที่เหมาะสม',
      envFileRecommendation: 'ตรวจสอบให้แน่ใจว่าไฟล์สภาพแวดล้อมไม่สามารถเข้าถึงได้จากไดเรกทอรีเว็บ และการกำหนดค่าเซิร์ฟเวอร์บล็อกการเข้าถึงไฟล์ที่ละเอียดอ่อนอย่างเหมาะสม',
      gitRepoRecommendation: 'ตรวจสอบให้แน่ใจว่าไดเรกทอรี .git ถูกรักษาความปลอดภัยอย่างเหมาะสมและไม่สามารถเข้าถึงได้จากเว็บ',
      noVulnerabilitiesFound: 'ไม่พบช่องโหว่',
      systemSecure: 'ระบบของคุณดูเหมือนจะปลอดภัย ตรวจสอบต่อเนื่องอย่างสม่ำเสมอ',
      loadingScan: 'กำลังโหลดผลสแกน...',
      occurrences: 'การเกิดขึ้น',
      firstSeen: 'เห็นครั้งแรก',
      lastSeen: 'เห็นครั้งสุดท้าย',
      timestamp: 'เวลา',
      message: 'ข้อความ',
      service: 'บริการ',
      type: 'ประเภท',
      severity: 'ความรุนแรง',
      url: 'URL',
      matchedTerm: 'คำที่ตรงกัน',
      lineNumber: 'หมายเลขบรรทัด',
      lineNumbers: 'หมายเลขบรรทัด',
      showLess: 'แสดงน้อยลง',
      showMore: 'แสดงปัญหาทั้งหมด',
      // --- NEW KEY ---
      lastScanJustNow: "เมื่อสักครู่"
    },
    userEdit: {
      title: 'แก้ไขผู้ใช้',
      loading: 'กำลังโหลดข้อมูลผู้ใช้...',
      userInfo: 'ข้อมูลผู้ใช้',
      userId: 'ID ผู้ใช้',
      loginName: 'ชื่อเข้าสู่ระบบ',
      fullName: 'ชื่อเต็ม',
      dob: 'วันเกิด',
      email: 'อีเมล',
      emailVerified: 'อีเมลได้รับการตรวจสอบ',
      verified: 'ได้รับการตรวจสอบ',
      notVerified: 'ไม่ได้รับการตรวจสอบ',
      createdAt: 'สร้างเมื่อ',
      lastLogin: 'เข้าสู่ระบบล่าสุด',
      never: 'ไม่เคย',
      accountSettings: 'การตั้งค่าบัญชี',
      accountStatus: 'สถานะบัญชี',
      accountEnabled: 'บัญชีเปิดใช้งาน',
      cannotDisableSelf: 'คุณไม่สามารถปิดใช้งานบัญชีของตัวเองได้',
      accountRole: 'บทบาทบัญชี',
      adminRole: 'บทบาทผู้ดูแล',
      cannotChangeOwnRole: 'คุณไม่สามารถเปลี่ยนบทบาทของตัวเองได้',
      adminActions: 'การกระทำของผู้ดูแล',
      verifyEmail: 'ตรวจสอบอีเมล',
      resetPassword: 'ส่งรีเซ็ตรหัสผ่าน',
      forceLogout: 'บังคับออกจากระบบ',
      failedToLoad: 'ล้มเหลวในการโหลดข้อมูลผู้ใช้',
      errorLoading: 'ข้อผิดพลาดในการโหลดข้อมูลผู้ใช้',
      saveSuccess: 'อัปเดตการตั้งค่าผู้ใช้สำเร็จ',
      errorSaving: 'ข้อผิดพลาดในการบันทึกการตั้งค่าผู้ใช้',
      verifyEmailSuccess: 'ส่งอีเมลตรวจสอบสำเร็จ',
      emailVerificationFailed: 'ล้มเหลวในการส่งอีเมลตรวจสอบ',
      errorVerifyingEmail: 'ข้อผิดพลาดในการส่งอีเมลตรวจสอบ',
      passwordResetSent: 'ส่งอีเมลรีเซ็ตรหัสผ่านแล้ว',
      passwordResetFailed: 'ล้มเหลวในการส่งรีเซ็ตรหัสผ่าน',
      errorSendingReset: 'ข้อผิดพลาดในการส่งรีเซ็ตรหัสผ่าน',
      logoutForced: 'ผู้ใช้ถูกออกจากระบบแล้ว',
      logoutFailed: 'ล้มเหลวในการบังคับออกจากระบบ',
      errorForcingLogout: 'ข้อผิดพลาดในการบังคับออกจากระบบ',
      // --- NEW KEY ---
      userUpdated: "อัปเดตผู้ใช้สำเร็จ"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "การจัดการลำดับชั้นความรู้ (หมายเหตุ: ภาษาอังกฤษเสมอ - เพิ่มการแปล)",
      addCategory: "เพิ่มหมวดหมู่ใหม่",
      loading: "กำลังโหลดลำดับชั้น...",
      addService: "เพิ่มบริการ",
      editCategory: "แก้ไขหมวดหมู่",
      deleteCategory: "ลบหมวดหมู่",
      editService: "แก้ไขบริการ",
      deleteService: "ลบบริการ",
      empty: 'ไม่พบหมวดหมู่ คลิก "เพิ่มหมวดหมู่ใหม่" เพื่อเริ่มต้น',
      formTitleCreateCategory: "สร้างหมวดหมู่ใหม่",
      formTitleAddService: 'เพิ่มบริการใน "{categoryName}"',
      formTitleEditCategory: 'แก้ไขหมวดหมู่: "{itemName}"',
      formTitleEditService: 'แก้ไขบริการ: "{itemName}"',
      nameEnLabel: "ชื่อ (ภาษาอังกฤษ)",
      translationsTitle: "การแปลสำหรับแสดงผล",
      loadingTranslations: "กำลังโหลดการแปล...",
      selectLang: "เลือกภาษา",
      translationPlaceholder: "ป้อนการแปล",
      deleteTranslation: "ลบการแปล",
      addTranslation: "+ เพิ่มการแปล",
      saveSuccess: "บันทึกรายการลำดับชั้นสำเร็จ",
      saveError: "ล้มเหลวในการบันทึกรายการลำดับชั้น",
      loadError: "ล้มเหลวในการโหลดลำดับชั้นความรู้",
      loadTranslationsError: "ล้มเหลวในการโหลดการแปล",
      confirmCancelTitle: "การเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
      confirmCancelEdit: "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณแน่ใจว่าต้องการยกเลิกหรือไม่?",
      confirmDeleteTitleCategory: "ลบหมวดหมู่?",
      confirmDeleteTitleService: "ลบบริการ?",
      confirmDeleteCategory: 'คุณแน่ใจว่าต้องการลบหมวดหมู่ "{itemName}" หรือไม่? การกระทำนี้ไม่สามารถยกเลิกได้',
      confirmDeleteService: 'คุณแน่ใจว่าต้องการลบบริการ "{itemName}" หรือไม่? การกระทำนี้ไม่สามารถยกเลิกได้',
      deleteSuccessCategory: "ลบหมวดหมู่สำเร็จ",
      deleteSuccessService: "ลบบริการสำเร็จ",
      deleteErrorCategory: "ล้มเหลวในการลบหมวดหมู่",
      deleteErrorService: "ล้มเหลวในการลบบริการ",
      duplicateLangError: "พบภาษาซ้ำในการแปล โปรดลบออก"
    },
    // --- NEW OBJECT ---
    documents: {
      title: "การจัดการเอกสาร",
      addLink: "เพิ่มจากลิงก์",
      uploadFiles: "อัปโหลดไฟล์",
      searchPlaceholder: "ค้นหาตามชื่อไฟล์...",
      allStatuses: "สถานะทั้งหมด",
      statusPending: "รอดำเนินการ",
      statusIngested: "นำเข้าข้อมูลแล้ว",
      statusRetracted: "ดึงกลับแล้ว",
      // --- NEW STATUSES ADDED ---
      statusIngesting: "กำลังนำเข้าข้อมูล",
      statusError: "การนำเข้าข้อมูลล้มเหลว",
      statusWarning: "นำเข้าข้อมูลแล้วพร้อมคำเตือน",
      // ---
      ingestSelected: "นำเข้าข้อมูลที่เลือก",
      colFileName: "ชื่อไฟล์",
      colStatus: "สถานะ",
      colLabels: "ป้ายกำกับ",
      colUploadDate: "วันที่อัปโหลด",
      colSize: "ขนาด",
      loading: "กำลังโหลดเอกสาร...",
      empty: "ไม่พบเอกสาร",
      loadError: "ล้มเหลวในการโหลดเอกสาร",
      confirmIngestTitle: "ยืนยันการนำเข้าข้อมูลเป็นชุด",
      ingest: "นำเข้าข้อมูล",
      confirmIngestSelected: "คุณแน่ใจว่าต้องการนำเข้าไฟล์ที่เลือก {count} ไฟล์หรือไม่?",
      ingestQueuedSuccess: "ไฟล์ {count} ไฟล์ถูกจัดคิวเพื่อนำเข้าข้อมูลแล้ว",
      ingestQueuedError: "เกิดข้อผิดพลาดระหว่างกระบวนการนำเข้าข้อมูลเป็นชุด",
      uploadSuccessMultiple: "อัปโหลดไฟล์ {count} ไฟล์สำเร็จ",
      linkSubmitSuccess: 'รวบรวมข้อมูลและบันทึก "{fileName}" สำเร็จ',
      actionSuccess: 'การดำเนินการ "{action}" กับไฟล์ {fileId} สำเร็จ',
      metadataUpdateSuccess: 'อัปเดตข้อมูลเมตาสำหรับไฟล์ {fileId} แล้ว'
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'สร้างรหัสผ่านใหม่',
    tokenLabel: 'โทเค็นรีเซ็ต',
    tokenPlaceholder: 'ป้อนโทเค็นรีเซ็ต',
    validateButton: 'ตรวจสอบโทเค็น',
    newPasswordLabel: 'รหัสผ่านใหม่',
    newPasswordPlaceholder: 'สร้างรหัสผ่านใหม่',
    confirmNewPasswordLabel: 'ยืนยันรหัสผ่านใหม่',
    confirmNewPasswordPlaceholder: 'ยืนยันรหัสผ่านใหม่ของคุณ',
    resetButton: 'รีเซ็ตรหัสผ่าน',
    processing: 'กำลังรีเซ็ต...',
    rememberedPassword: 'จำรหัสผ่านของคุณได้ไหม?',
    backToLogin: 'กลับไปเข้าสู่ระบบ',
    supportMessage: 'ต้องการความช่วยเหลือ? ติดต่อทีมสนับสนุนของเรา',
    passwordRequirements: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร โดยมีอย่างน้อย 1 ตัวเลข 1 ตัวอักษรตัวใหญ่ และ 1 ตัวอักษรพิเศษ',
    passwordsDoNotMatch: 'รหัสผ่านไม่ตรงกัน',
    resetSuccess: 'รีเซ็ตรหัสผ่านของคุณสำเร็จ',
    resetFailed: 'ไม่สามารถรีเซ็ตรหัสผ่านได้ โปรดลองอีกครั้ง',
    noTokenProvided: 'โปรดระบุโทเค็นรีเซ็ต',
    expiredToken: 'โทเค็นรีเซ็ตนี้หมดอายุแล้ว โปรดขอใหม่',
    invalidToken: 'โทเค็นรีเซ็ตไม่ถูกต้องหรือไม่รู้จัก',
    validatingToken: 'กำลังตรวจสอบโทเค็น...',
    redirecting: 'กำลังเปลี่ยนเส้นทางไปยังหน้าล็อกอิน...',
    passwordStrength: 'ความแข็งแกร่งของรหัสผ่าน',
    strengthLabels: {
      veryWeak: 'อ่อนมาก',
      weak: 'อ่อน',
      fair: 'พอใช้',
      good: 'ดี',
      strong: 'แข็งแกร่ง'
    },
    passwordSuggestions: {
      atLeast8Chars: 'ใช้อย่างน้อย 8 ตัวอักษร',
      addUppercase: 'เพิ่มตัวอักษรตัวใหญ่',
      addLowercase: 'เพิ่มตัวอักษรตัวเล็ก',
      addNumbers: 'เพิ่มตัวเลข',
      addSpecialChars: 'เพิ่มตัวอักษรพิเศษ'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'รีเซ็ตรหัสผ่านของคุณ',
    emailLabel: 'ที่อยู่อีเมล',
    emailPlaceholder: 'ป้อนอีเมลของคุณ',
    resetButton: 'ส่งลิงก์รีเซ็ต',
    processing: 'กำลังส่ง...',
    rememberPassword: 'จำรหัสผ่านของคุณได้ไหม?',
    backToLogin: 'กลับไปเข้าสู่ระบบ',
    supportMessage: 'ต้องการความช่วยเหลือ? ติดต่อทีมสนับสนุนของเรา',
    invalidEmail: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
    resetRequestSuccess: 'ลิงก์รีเซ็ตรหัสผ่านถูกส่งไปยังอีเมลของคุณแล้ว',
    resetRequestFailed: 'ไม่สามารถส่งลิงก์รีเซ็ตรหัสผ่านได้ โปรดลองอีกครั้ง',
    checkEmail: 'โปรดตรวจสอบอีเมลของคุณสำหรับคำแนะนำเพิ่มเติม'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "สร้างบัญชีใหม่",
    username: "ชื่อผู้ใช้",
    usernamePlaceholder: "ป้อนชื่อผู้ใช้",
    email: "อีเมล",
    emailPlaceholder: "ป้อนอีเมลของคุณ",
    password: "รหัสผ่าน",
    passwordPlaceholder: "สร้างรหัสผ่าน",
    confirmPassword: "ยืนยันรหัสผ่าน",
    confirmPasswordPlaceholder: "ยืนยันรหัสผ่านของคุณ",
    acceptTerms: "ฉันยอมรับ",
    termsOfService: "ข้อกำหนดการบริการ",
    registerButton: "สร้างบัญชี",
    processing: "กำลังประมวลผล...",
    alreadyHaveAccount: "มีบัญชีอยู่แล้ว?",
    loginNow: "เข้าสู่ระบบ",
    privacyNotice: "โดยการลงทะเบียน คุณยอมรับข้อกำหนดการบริการและนโยบายความเป็นส่วนตัวของเรา",
    usernameMinLength: "ชื่อผู้ใช้ต้องมีอย่างน้อย 3 ตัวอักษร",
    invalidEmail: "โปรดป้อนที่อยู่อีเมลที่ถูกต้อง",
    passwordRequirements: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร โดยมีอย่างน้อย 1 ตัวเลขและ 1 ตัวอักษรตัวใหญ่",
    passwordsDoNotMatch: "รหัสผ่านไม่ตรงกัน",
    mustAcceptTerms: "คุณต้องยอมรับข้อกำหนดการบริการ",
    registrationFailed: "การลงทะเบียนล้มเหลว โปรดลองอีกครั้ง",
    usernameExists: "ชื่อผู้ใช้มีอยู่แล้ว",
    emailExists: "อีเมลมีอยู่แล้ว",
    registrationSuccess: "การลงทะเบียนสำเร็จ!",
    verificationEmailSent: "ส่งอีเมลตรวจสอบไปยัง {email} แล้ว",
    checkEmailInstructions: "โปรดตรวจสอบอีเมลของคุณและทำตามคำแนะนำเพื่อตรวจสอบบัญชีของคุณก่อนเข้าสู่ระบบ",
    backToLogin: "กลับไปเข้าสู่ระบบ",
    noEmailReceived: "ไม่ได้รับอีเมล?",
    resendVerification: "ส่งอีเมลตรวจสอบอีกครั้ง",
    verificationResent: "ส่งอีเมลตรวจสอบอีกครั้งแล้ว",
    verificationResendFailed: "ล้มเหลวในการส่งอีเมลตรวจสอบอีกครั้ง โปรดลองอีกครั้ง",
    usernameInvalidChars: 'ชื่อผู้ใช้สามารถมีเฉพาะตัวอักษร ตัวเลข ขีดล่าง จุด และขีดกลาง',
    networkError: 'ข้อผิดพลาดเครือข่าย โปรดตรวจสอบการเชื่อมต่อของคุณและลองอีกครั้ง'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'ชื่อผู้ใช้',
    password: 'รหัสผ่าน',
    loginButton: 'เข้าสู่ระบบ',
    or: 'หรือ',
    savedAccounts: 'บัญชีที่บันทึกไว้',
    loginSuccess: 'เข้าสู่ระบบสำเร็จ',
    loginError: 'เข้าสู่ระบบล้มเหลว โปรดตรวจสอบข้อมูลประจำตัวของคุณ',
    googleLogin: 'ดำเนินการต่อด้วย Google',
    facebookLogin: 'ดำเนินการต่อด้วย Facebook',
    rememberMe: 'จำฉันไว้',
    forgotPassword: 'ลืมรหัสผ่าน?',
    noAccount: 'ไม่มีบัญชี?',
    createAccount: 'สร้างบัญชี',
    registerNow: "ลงทะเบียนตอนนี้",
    termsAndPolicy: 'โดยการเข้าสู่ระบบ คุณยอมรับข้อกำหนดการบริการและนโยบายความเป็นส่วนตัวของเรา',
    loggingIn: "กำลังเข้าสู่ระบบ...",
    fieldsRequired: "ชื่อผู้ใช้และรหัสผ่านจำเป็น",
    invalidCredentials: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
    tooManyAttempts: "พยายามเข้าสู่ระบบมากเกินไป โปรดลองอีกครั้งในภายหลัง",
    loginFailed: "เข้าสู่ระบบล้มเหลว โปรดลองอีกครั้ง",
    oauthNotImplemented: "การเข้าสู่ระบบโซเชียลยังไม่ถูกนำไปใช้",
    savedLoginNotImplemented: "การเข้าสู่ระบบบัญชีที่บันทึกไว้ยังไม่ถูกนำไปใช้"
  },
  charts: {
    tooltip: {
      title: 'วันที่',
      totalQueries: 'คำถามทั้งหมด',
      uniqueUsers: 'ผู้ใช้ที่ไม่ซ้ำ'
    },
    day: 'วัน',
    noData: 'ไม่มีข้อมูล',
    notAvailable: 'N/A',
    topQueries: 'คำถามยอดนิยม',
    categoryDistribution: 'การใช้งานพื้นที่ความรู้',
    usageTrend: 'แนวโน้มการใช้งาน'
  },
  analytics: {
    title: 'การวิเคราะห์ข้อมูลและข้อมูลเชิงลึก',
    loading: 'กำลังโหลดข้อมูลการวิเคราะห์...',
    period: 'ช่วงเวลา',
    charts: {
      satisfactionHeatmap: "ความพึงพอใจตามพื้นที่ความรู้",
      satisfactionSubtitle: "คะแนนเปอร์เซ็นต์ตามเวลา"
    },
    timePeriods: {
      week4: "4 สัปดาห์ที่แล้ว",
      week3: "3 สัปดาห์ที่แล้ว",
      week2: "2 สัปดาห์ที่แล้ว",
      week1: "สัปดาห์ที่แล้ว",
      current: "ปัจจุบัน"
    },
    errors: {
      loading: "ล้มเหลวในการโหลดข้อมูลความพึงพอใจ โปรดลองอีกครั้ง",
    },
    status: {
      loading: 'กำลังโหลด...',
      noData: 'ไม่มีข้อมูลสำหรับช่วงนี้',
      error: 'ล้มเหลวในการโหลดข้อมูลการวิเคราะห์',
      online: "ระบบออนไลน์",
      offline: "ระบบออฟไลน์",
      responseTime: "เวลาตอบสนองเฉลี่ย",
      queueLength: "คิว",
      uptime: "เวลาทำงาน"
    },
    periods: {
      daily: 'รายวัน',
      weekly: 'รายสัปดาห์',
      monthly: 'รายเดือน',
      allTime: 'ตลอดเวลา'
    },
    metrics: {
      totalQueries: 'คำถามทั้งหมด',
      uniqueUsers: 'ผู้ใช้ที่ไม่ซ้ำ',
      avgResponseTime: 'เวลาตอบสนองเฉลี่ย',
      satisfaction: 'ความพึงพอใจของผู้ใช้'
    },
    table: {
      rank: 'อันดับ',
      query: 'คำถาม',
      count: 'จำนวน',
      avgTime: 'เวลาเฉลี่ย'
    },
    chartLabels: {
      categories: 'พื้นที่',
      serviceCategories: 'พื้นที่ความรู้',
      byUsage: 'ตามการใช้งาน',
      category: 'พื้นที่'
    },
    tooltips: {
      selectPeriod: 'เลือกช่วงเวลา',
      selectDate: 'เลือกวันที่',
      exportData: 'ส่งออกข้อมูล'
    },
    gauge: {
      historical: 'แนวโน้มทางประวัติศาสตร์',
      vsPrevious: 'เทียบกับช่วงก่อนหน้า',
      target: 'เป้าหมาย'
    },
    ratings: {
      poor: "แย่",
      average: "เฉลี่ย",
      good: "ดี",
      excellent: "ยอดเยี่ยม"
    },
    slower: 'ช้ากว่า',
    faster: 'เร็วกว่า',
    percentage: 'เปอร์เซ็นต์',
    note: 'ด้านล่างคือสถิติการใช้งานและสรุปความคิดเห็นจากผู้ใช้',
    usageStats: 'สถิติการใช้งาน',
    peakUsers: 'ผู้ใช้พร้อมกันสูงสุด',
    activeChats: 'แชทที่ใช้งาน',
    usageTrend: 'แนวโน้มการใช้งาน',
    topQueries: 'คำถามยอดนิยม',
    feedbackSamples: 'ตัวอย่างความคิดเห็นจากผู้ใช้',
    close: 'ปิด',
    chartComingSoon: 'การแสดงผลกราฟแบบโต้ตอบกำลังมาเร็วๆ นี้...',
    retry: 'ลองใหม่',
    dailyQueries: 'คำถามรายวัน',
    export: 'ส่งออกข้อมูล',
    dateRange: 'ช่วงวันที่',
    startDate: 'วันที่เริ่มต้น',
    endDate: 'วันที่สิ้นสุด',
    rank: 'อันดับ',
    query: 'คำถาม',
    count: 'จำนวน',
    avgTime: 'เวลาเฉลี่ย',
    serviceUsage: 'การใช้งานพื้นที่ความรู้',
    usageTrends: 'แนวโน้มการใช้งาน',
    week: 'สัปดาห์ที่แล้ว',
    month: 'เดือนที่แล้ว',
    quarter: 'ไตรมาสที่แล้ว',
    year: 'ปีที่แล้ว',
    uniqueUsers: 'ผู้ใช้ที่ไม่ซ้ำ',
    satisfactionRate: 'อัตราความพึงพอใจ',
    satisfactionAnalysis: 'การวิเคราะห์ความพึงพอใจของผู้ใช้'
  },
  brandName: 'Genie AI: ผู้ช่วยรัฐบาลดิจิทัลของคุณ',
  nav: {
    systemStatus: 'สถานะระบบ',
    menu: 'เมนู',
    analytics: 'การวิเคราะห์',
    userProfile: 'โปรไฟล์ผู้ใช้',
    settings: 'การตั้งค่า',
    logout: 'ออกจากระบบ',
    profile: 'โปรไฟล์ของฉัน',
    toggleSidebar: 'สลับแถบด้านข้าง',
    changeLanguage: 'เปลี่ยนภาษา',
    administration: "การบริหาร",
    languages: {
      english: 'อังกฤษ',
      french: 'ฝรั่งเศส',
      swahili: 'สวาฮิลี'
    }
  },
  systemStatus: {
    title: 'สถานะบริการ',
    services: 'บริการ',
    operational: 'ใช้งานได้',
    degraded: 'เสื่อมโทรม',
    outage: 'ขัดข้อง',
    allOperational: 'ระบบทั้งหมด',
    someIssues: 'ปัญหาบางอย่าง',
    majorIssues: 'ปัญหาหลัก',
    checking: 'กำลังตรวจสอบ...',
    nextDeadline: 'กำหนดเวลาถัดไป',
    days: 'วัน',
    viewDetails: 'ดูรายละเอียด'
  },
  services: {
    eCitizen: 'พอร์ทัล eCitizen',
    taxFiling: 'ระบบยื่นภาษี',
    idApplication: 'การสมัคร ID',
    businessReg: 'การจดทะเบียนธุรกิจ',
    drivingLicense: 'ใบขับขี่'
  },
  deadlines: {
    taxFiling: 'กำหนดเวลายื่นภาษี',
    businessRenewal: 'การต่ออายุใบอนุญาตธุรกิจ',
    idRenewal: 'การต่ออายุบัตรประชาชน',
    vehicleRegistration: 'กำหนดเวลาจดทะเบียนยานพาหนะ'
  },
  sidebar: {
    governmentServices: 'พื้นที่ความรู้',
    chatHistory: 'ประวัติแชท',
    searchPlaceholder: 'ค้นหาพื้นที่ความรู้...',
    createFolder: 'สร้างโฟลเดอร์',
    editFolder: 'แก้ไขโฟลเดอร์',
    folderName: 'ชื่อโฟลเดอร์',
    folderNamePlaceholder: 'ป้อนชื่อโฟลเดอร์',
    moveChat: 'ย้ายแชท',
    moveChatTo: 'ย้ายแชทไปยัง',
    selectFolder: 'เลือกโฟลเดอร์',
    deleteChat: 'ลบแชท',
    deleteChatConfirm: 'คุณแน่ใจว่าต้องการลบแชทนี้หรือไม่?',
    deleteChatWarning: 'การกระทำนี้ไม่สามารถยกเลิกได้',
    renameChat: "เปลี่ยนชื่อแชท",
    chatTitle: "ชื่อแชท",
    chatTitlePlaceholder: "ป้อนชื่อสำหรับแชทนี้",
    deleteFolder: "ลบโฟลเดอร์",
    deleteFolderConfirm: "คุณแน่ใจว่าต้องการลบโฟลเดอร์ '{name}' หรือไม่?",
    chatsMoveWarning: "แชททั้งหมดในโฟลเดอร์นี้จะถูกย้ายไปยังโฟลเดอร์เริ่มต้น",
    weatherTitle: "พยากรณ์อากาศ",
    weatherLoading: "กำลังโหลดข้อมูลอากาศ...",
    weatherError: "ไม่สามารถโหลดข้อมูลอากาศได้ โปรดลองอีกครั้ง",
    weatherLocationLoading: 'กำลังโหลดตำแหน่ง...',
    weatherErrorDefault: 'ไม่สามารถดึงข้อมูลสภาพอากาศได้',
    weatherGeolocationUnsupported: 'เบราว์เซอร์ของคุณไม่รองรับการระบุตำแหน่งทางภูมิศาสตร์',
    weatherRefresh: 'รีเฟรชสภาพอากาศ',
    weatherConditions: {
      clear: 'แจ่มใส',
      partlycloudy: 'มีเมฆบางส่วน',
      cloudy: 'มีเมฆมาก',
      overcast: 'ครึ้มฟ้า',
      rain: 'ฝนตก',
      shower: 'ฝนปรอย',
      thunderstorm: 'พายุฝนฟ้าคะนอง',
      snow: 'หิมะ'
    },
    folders: "โฟลเดอร์",
    emptyFolder: "โฟลเดอร์นี้ว่างเปล่า ย้ายการสนทนามาที่นี่จากเมนูแชท",
    title: 'ข้อมูลและทรัพยากร',
    noChats: 'ไม่มีแชทล่าสุด',
    relatedDocs: 'เอกสารที่เกี่ยวข้อง',
    noDocuments: 'ไม่มีเอกสารที่เกี่ยวข้อง',
    faq: 'คำถามที่พบบ่อย',
    tab: {
      all: 'แชททั้งหมด',
      folders: 'โฟลเดอร์',
      starred: 'ที่ติดดาว',
      archived: 'ที่เก็บถาวร'
    },
    savedChats: 'แชทที่บันทึกไว้',
    chats: "แชท",
    allChats: "แชททั้งหมด",
    noFolder: "ไม่มีโฟลเดอร์",
    starredChats: "แชทที่ติดดาว",
    archivedChats: "แชทที่เก็บถาวร",
    noStarredChats: "ยังไม่มีการสนทนาที่ติดดาว ติดดาวการสนทนาเพื่อเพิ่มที่นี่",
    noArchivedChats: "ยังไม่มีการสนทนาที่เก็บถาวร",
    noSearchResults: 'ไม่พบการสนทนาสำหรับ "{term}"',
    loadingChats: "กำลังโหลดการสนทนา...",
    errorLoadingConversations: "ล้มเหลวในการโหลดการสนทนา โปรดลองอีกครั้ง",
    errorLoadingUser: "ข้อมูลผู้ใช้ไม่สมบูรณ์ โปรดรีโหลดหน้า",
    errorNoUser: "ข้อมูลผู้ใช้หายไป โปรดรีโหลดหน้า",
    retry: "ลองใหม่",
    message: "ข้อความ",
    messages: "ข้อความ",
    created: "สร้าง",
    updated: "อัปเดต",
    star: "ติดดาว",
    unstar: "ยกเลิกติดดาว",
    archive: "เก็บถาวร",
    chatStarred: "การสนทนาถูกติดดาวแล้ว",
    chatUnstarred: "การสนทนายกเลิกติดดาวแล้ว",
    chatArchived: "การสนทนาถูกเก็บถาวรแล้ว",
    chatUnarchived: "การสนทนายกเลิกเก็บถาวรแล้ว",
    errorUpdatingChat: "ล้มเหลวในการอัปเดตการสนทนา",
    chatRenamed: "เปลี่ยนชื่อการสนทนาสำเร็จ",
    errorRenamingChat: "ล้มเหลวในการเปลี่ยนชื่อการสนทนา",
    chatDeleted: "ลบการสนทนาสำเร็จ",
    errorDeletingChat: "ล้มเหลวในการลบการสนทนา",
    chatMoved: "ย้ายการสนทนาสำเร็จ",
    errorMovingChat: "ล้มเหลวในการย้ายการสนทนา",
    noPreview: "ไม่มีตัวอย่าง",
    searchConversations: 'ค้นหาการสนทนา...',
    selectFolderInstruction: "เลือกโฟลเดอร์เพื่อดูการสนทนา",
    folderCreated: "สร้างโฟลเดอร์สำเร็จ",
    errorCreatingFolder: "ล้มเหลวในการสร้างโฟลเดอร์",
    errorLoadingFolders: "ล้มเหลวในการโหลดโฟลเดอร์",
    folderUpdated: "อัปเดตโฟลเดอร์สำเร็จ",
    errorUpdatingFolder: "ล้มเหลวในการอัปเดตโฟลเดอร์",
    folderDeleted: "ลบโฟลเดอร์สำเร็จ",
    errorDeletingFolder: "ล้มเหลวในการลบโฟลเดอร์",
    chatRemovedFromFolders: "ลบการสนทนาออกจากโฟลเดอร์",
    errorRemovingChat: "ล้มเหลวในการลบการสนทนาจากโฟลเดอร์",
    id: "ID",
    labels: "ป้ายกำกับ",
    confidence: "ความมั่นใจ",
    unknown: "ไม่ทราบ"
  },
  leftPanel: {
    cat1: {
      name: '1. เอกลักษณ์และการทะเบียนพลเรือน',
      children: ['สูติบัตร', 'บัตรประชาชนแห่งชาติ', 'หนังสือเดินทาง', 'ทะเบียนสมรสและมรณบัตร', 'การลงทะเบียนผู้มีสิทธิเลือกตั้ง']
    },
    cat2: {
      name: '2. การดูแลสุขภาพและบริการสังคม',
      children: ['การเข้าถึงการดูแลสุขภาพสาธารณะ', 'โปรแกรมการฉีดวัคซีน', 'ประกันสุขภาพ', 'ผลประโยชน์คนพิการ', 'สวัสดิการและความช่วยเหลือด้านอาหาร']
    },
    cat3: {
      name: '3. การศึกษาและการเรียนรู้',
      children: ['โรงเรียนรัฐและมหาวิทยาลัย', 'ทุนการศึกษาและเงินกู้ยืมนักศึกษา', 'โปรแกรมการศึกษาผู้ใหญ่', 'ทรัพยากรการเรียนรู้ออนไลน์']
    },
    cat4: {
      name: '4. การจ้างงานและบริการแรงงาน',
      children: ['การค้นหางานและผลประโยชน์การว่างงาน', 'การคุ้มครองแรงงานและสิทธิแรงงาน', 'กฎระเบียบความปลอดภัยในที่ทำงาน', 'การฝึกทักษะและการฝึกงาน']
    },
    cat5: {
      name: '5. ภาษีและรายได้',
      children: ['การยื่นภาษีเงินได้และการคืนเงิน', 'การชำระภาษีทรัพย์สิน', 'การปฏิบัติตามภาษีธุรกิจ', 'ศุลกากรและอากรนำเข้า']
    },
    cat6: {
      name: '6. ความปลอดภัยสาธารณะและความยุติธรรม',
      children: ['ตำรวจและบริการฉุกเฉิน', 'ศาลและบริการช่วยเหลือทางกฎหมาย', 'การรายงานอาชญากรรม', 'กฎหมายคุ้มครองผู้บริโภค']
    },
    cat7: {
      name: '7. การขนส่งและการเคลื่อนไหว',
      children: ["ใบขับขี่และการจดทะเบียนยานพาหนะ", 'การขนส่งสาธารณะและโครงสร้างพื้นฐาน', 'การละเมิดกฎจราจรและค่าปรับ', 'โปรแกรมความปลอดภัยทางถนน']
    },
    cat8: {
      name: '8. ที่อยู่อาศัยและการพัฒนาเมือง',
      children: ['ความช่วยเหลือที่อยู่อาศัยสาธารณะ', 'การจดทะเบียนทรัพย์สินและบันทึกที่ดิน', 'เงินกู้และเงินอุดหนุนที่อยู่อาศัย', 'การแบ่งเขตและใบอนุญาตก่อสร้าง']
    },
    cat9: {
      name: '9. สาธารณูปโภคและสิ่งแวดล้อม',
      children: ['บริการน้ำและไฟฟ้า', 'การจัดการขยะและรีไซเคิล', 'กฎระเบียบสิ่งแวดล้อม', 'โครงการพลังงานหมุนเวียน']
    },
    cat10: {
      name: '10. ธุรกิจและการค้า',
      children: ['การจดทะเบียนและใบอนุญาตธุรกิจ', 'กฎระเบียบและใบอนุญาตการค้า', 'ทุนและสิ่งจูงใจธุรกิจขนาดเล็ก', 'การสนับสนุนอีคอมเมิร์ซและธุรกิจดิจิทัล']
    },
    cat11: {
      name: '11. ประกันสังคมและบำนาญ',
      children: ['ผลประโยชน์การเกษียณอายุ', 'การจัดการกองทุนบำนาญ', 'ผลประโยชน์ผู้รอดชีวิต', 'บำนาญคนพิการ']
    },
    cat12: {
      name: '12. ชุมชนและการมีส่วนร่วมพลเมือง',
      children: ['การลงคะแนนและการเลือกตั้ง', 'ความคิดเห็นสาธารณะและข้อร้องเรียนพลเมือง', 'อาสาสมัครและโปรแกรมชุมชน', 'การมีส่วนร่วมในรัฐบาลท้องถิ่น']
    }
  },
  settings: {
    title: 'การตั้งค่า',
    save: 'บันทึก',
    close: 'ปิด',
    saveSettings: 'บันทึกการตั้งค่า',
    savingSettings: "กำลังบันทึกการตั้งค่าของคุณ...",
    settingsSaved: "บันทึกการตั้งค่าสำเร็จ!",
    saveSuccess: 'บันทึกการตั้งค่าสำเร็จ',
    saveError: 'ข้อผิดพลาดในการบันทึกการตั้งค่า',
    display: 'แสดงผล',
    displayLanguage: 'ภาษาที่แสดง',
    languages: {
      english: 'อังกฤษ',
      french: 'ฝรั่งเศส',
      swahili: 'สวาฮิลี'
    },
    theme: 'ธีม',
    themes: {
      light: 'สว่าง',
      dark: 'มืด',
      system: 'ระบบ'
    },
    fontSize: 'ขนาดตัวอักษร',
    notifications: 'การแจ้งเตือน',
    emailUpdates: 'อัปเดตอีเมล',
    soundNotifications: 'การแจ้งเตือนเสียง',
    accountManagement: 'การจัดการบัญชี',
    emailAddress: 'ที่อยู่อีเมล',
    emailAddressPlaceholder: 'ที่อยู่อีเมลของคุณ',
    password: 'รหัสผ่าน',
    changePassword: 'เปลี่ยนรหัสผ่าน',
    resetUserData: 'รีเซ็ตข้อมูลผู้ใช้',
    resetUserDataDesc: 'นี้จะล้างข้อมูลโปรไฟล์และประวัติแชททั้งหมดของคุณ',
    deleteAccount: 'ลบบัญชี',
    deleteAccountDesc: 'นี้จะลบบัญชีของคุณและข้อมูลที่เกี่ยวข้องทั้งหมดอย่างถาวร',
    edit: 'แก้ไข',
    standardAccount: 'บัญชีมาตรฐาน',
    confirmEmailChange: 'ยืนยันการเปลี่ยนอีเมล',
    pleaseEnterPassword: 'โปรดป้อนรหัสผ่านของคุณ',
    cancel: 'ยกเลิก',
    account: {
      title: 'บัญชี',
      resetDescription: 'นี้จะล้างข้อมูลโปรไฟล์และประวัติแชททั้งหมดของคุณ',
      confirmReset: 'คุณแน่ใจว่าต้องการรีเซ็ตข้อมูลทั้งหมดของคุณหรือไม่? ไม่สามารถยกเลิกได้',
      resetComplete: 'ข้อมูลของคุณถูกรีเซ็ตแล้ว'
    },
    language: {
      title: 'ภาษา',
      selectLabel: 'ภาษาที่แสดง'
    },
    appearance: {
      title: 'ลักษณะ',
      lightTheme: 'สว่าง',
      darkTheme: 'มืด',
      systemTheme: 'ระบบ'
    },
    confirmDeleteAccount: 'คุณแน่ใจว่าต้องการลบบัญชีของคุณหรือไม่? การกระทำนี้ไม่สามารถยกเลิกได้',
    confirmAccountDeletion: 'ยืนยันการลบบัญชี',
    accountDeletionWarning: 'คำเตือน: การกระทำนี้ถาวรและไม่สามารถยกเลิกได้ ข้อมูลทั้งหมดของคุณจะถูกลบอย่างถาวร',
    deletionReason: 'เหตุผลในการลบ (เลือกได้):',
    deletionReasonPlaceholder: 'อะไรทำให้คุณตัดสินใจลบบัญชี?',
    enterPasswordConfirm: 'ป้อนรหัสผ่านของคุณเพื่อยืนยัน:',
    currentPasswordPlaceholder: 'รหัสผ่านปัจจุบันของคุณ',
    deleting: 'กำลังลบ...',
    permanentlyDeleteAccount: 'ลบบัญชี',
    accountDeletedSuccess: 'บัญชีของคุณถูกลบสำเร็จ',
    incorrectPassword: 'รหัสผ่านไม่ถูกต้อง',
    accountDeletionFailed: 'ล้มเหลวในการลบบัญชี โปรดลองอีกครั้งในภายหลัง',
    confirmChange: 'ยืนยันการเปลี่ยนแปลง',
    processing: 'กำลังประมวลผล...',
    userDataReset: 'ข้อมูลโปรไฟล์ของคุณถูกรีเซ็ตสำเร็จ',
    failedToResetUserData: 'ล้มเหลวในการรีเซ็ตข้อมูลโปรไฟล์ของคุณ โปรดลองอีกครั้งในภายหลัง',
    changingEmailTo: 'กำลังเปลี่ยนอีเมลของคุณเป็น',
    will: 'จะ',
    logOutSystem: 'ออกจากระบบ',
    sendVerificationLink: 'ส่งลิงก์ตรวจสอบไปยังอีเมลใหม่ของคุณ',
    requireVerification: 'ต้องตรวจสอบก่อนที่คุณจะเข้าสู่ระบบอีกครั้ง',
    checkNewEmailVerification: 'โปรดตรวจสอบอีเมลใหม่ของคุณสำหรับคำแนะนำการตรวจสอบ',
    unableToVerifyEmail: 'ไม่สามารถตรวจสอบอีเมลได้ โปรดลองอีกครั้ง',
    emailAlreadyInUse: 'อีเมลถูกใช้งานแล้ว',
    enterValidEmail: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
    failedToUpdateEmail: 'ล้มเหลวในการอัปเดตอีเมล โปรดลองอีกครั้ง',
    passwordResetInitiated: 'ลิงก์รีเซ็ตรหัสผ่านถูกส่งไปยังที่อยู่อีเมลของคุณแล้ว',
    unableToLoadUser: 'ไม่สามารถโหลดข้อมูลผู้ใช้ได้ โปรดลองอีกครั้ง',
    retry: 'ลองใหม่',
    user: 'ผู้ใช้',
    loadingUserInfo: 'กำลังโหลดข้อมูลผู้ใช้...',
    resetUserDataTitle: "รีเซ็ตข้อมูลผู้ใช้",
    confirmResetUserData: "คุณแน่ใจว่าต้องการรีเซ็ตข้อมูลโปรไฟล์ทั้งหมดของคุณหรือไม่? นี้จะล้างข้อมูลโปรไฟล์และประวัติแชททั้งหมดของคุณ แต่รักษาข้อมูลประจำตัวบัญชีของคุณ",
    reset: "รีเซ็ต",
    deleteAccountTitle: "ลบบัญชี"
  },
  userProfile: {
    title: 'โปรไฟล์ผู้ใช้',
    privacyInfo: "โดยการให้ข้อมูลเพิ่มเติม คุณจะได้รับคำตอบที่แม่นยำและมีความหมายมากขึ้นจากแชทบอท โปรดตรวจสอบ",
    privacyPolicyLink: 'นโยบายความเป็นส่วนตัว',
    tabComingSoon: 'แท็บนี้กำลังพัฒนาและจะพร้อมใช้งานเร็วๆ นี้',
    saveSuccess: 'บันทึกโปรไฟล์สำเร็จ',
    loadError: 'ข้อผิดพลาดในการโหลดข้อมูลโปรไฟล์',
    saveError: 'ข้อผิดพลาดในการบันทึกโปรไฟล์',
    confirmSaveTitle: "บันทึกโปรไฟล์",
    confirmSave: "คุณแน่ใจว่าต้องการบันทึกการเปลี่ยนแปลงเหล่านี้หรือไม่?",
    confirmCancel: 'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณแน่ใจว่าต้องการยกเลิกหรือไม่?',
    confirmLeave: 'คุณแน่ใจว่าต้องการออกหรือไม่? การเปลี่ยนแปลงที่ยังไม่ได้บันทึกจะสูญหาย',
    confirmDiscardChanges: 'ยกเลิกการเปลี่ยนแปลงที่ยังไม่ได้บันทึก?',
    uploadPhoto: 'อัปโหลดรูปภาพ',
    uploadFile: 'อัปโหลดไฟล์',
    photoRequirements: 'รูปภาพต้องชัดเจน ล่าสุด และแสดงใบหน้าของคุณเต็มใบ',
    biometricRequirements: 'ยอมรับเฉพาะไฟล์ข้อมูลชีวมิติอย่างเป็นทางการ',
    documentUpload: 'การอัปโหลดเอกสาร',
    validationTitle: 'โปรดแก้ไขข้อผิดพลาดต่อไปนี้:',
    profileIcon: 'ไอคอนโปรไฟล์',
    change: 'เปลี่ยน',
    chooseProfileIcon: 'เลือกไอคอนโปรไฟล์',
    presetIcons: 'ไอคอนที่ตั้งไว้ล่วงหน้า',
    upload: 'อัปโหลด',
    initials: 'ตัวย่อ',
    clickToUpload: 'คลิกเพื่ออัปโหลด',
    useThisImage: 'ใช้รูปภาพนี้',
    useInitials: 'ใช้ตัวย่อ',
    tabs: {
      tab1: 'ข้อมูลการระบุตัวตนส่วนบุคคล',
      tab2: 'การทะเบียนพลเรือนและเอกสาร',
      tab3: 'ข้อมูลที่อยู่และการอยู่อาศัย',
      tab4: 'เอกสารเอกลักษณ์และการเดินทาง',
      tab5: 'บันทึกสุขภาพและการแพทย์',
      tab6: 'ข้อมูลการจ้างงานและเศรษฐกิจ',
      tab7: 'บันทึกการศึกษาและวิชาการ',
      tab8: 'ข้อมูลทางการเงินและภาษี',
      tab9: 'ประกันสังคมและสวัสดิการ',
      tab10: 'บันทึกอาชญากรรมและกฎหมาย',
      tab11: 'การขนส่งและการเคลื่อนไหว',
      tab12: 'การมีส่วนร่วมพลเมืองและการเมือง'
    },
    actions: {
      cancel: 'ยกเลิก',
      save: 'บันทึกโปรไฟล์',
      previous: 'ก่อนหน้า',
      next: 'ถัดไป',
      saving: 'กำลังบันทึก...'
    },
    fields: {
      fullName: 'ชื่อเต็ม (รวมชื่อเล่น)',
      dob: 'วันเกิด',
      gender: 'เพศ',
      nationality: 'สัญชาติ',
      maritalStatus: 'สถานภาพสมรส',
      photograph: 'รูปถ่าย',
      biometric: 'ลายนิ้วมือ / ข้อมูลชีวมิติ',
      birthCert: 'สูติบัตร',
      deathCert: 'มรณบัตร',
      marriageDivorce: 'ทะเบียนสมรส / การหย่า',
      adoption: 'บันทึกการรับบุตรบุญธรรม',
      citizenship: 'เอกสารสัญชาติ / การแปลงสัญชาติ',
      immigration: 'ประวัติการเข้าเมืองและวีซ่า',
      currentAddress: 'ที่อยู่ปัจจุบัน',
      previousAddresses: 'ที่อยู่ก่อนหน้า',
      postalCode: 'รหัสไปรษณีย์',
      country: 'ประเทศ',
      residencyStatus: 'สถานะการอยู่อาศัย',
      homeOrRental: 'เจ้าของบ้านหรือรายละเอียดการเช่า',
      utilityBills: 'ใบแจ้งหนี้สาธารณูปโภคที่เชื่อมโยงกับที่อยู่',
      landRecords: 'บันทึกที่ดินและทรัพย์สิน',
      idCard: 'หมายเลขบัตรประชาชนแห่งชาติ',
      passport: 'รายละเอียดหนังสือเดินทาง',
      driversLicense: "ใบขับขี่",
      voterId: 'บัตรผู้มีสิทธิเลือกตั้ง',
      ssn: 'หมายเลขประกันสังคม / ประกันแห่งชาติ',
      militaryRecords: 'บันทึกการรับราชการทหาร',
      medicalHistory: 'ประวัติการแพทย์และสภาวะสุขภาพ',
      vaccinations: 'บันทึกการฉีดวัคซีน',
      insuranceDetails: 'รายละเอียดประกันสุขภาพ',
      disability: 'สถานะคนพิการ',
      bloodType: 'กรุ๊ปเลือด',
      organDonor: 'สถานะผู้บริจาคอวัยวะ',
      prescriptions: 'ใบสั่งยาและการรักษาที่ได้รับ',
      mentalHealth: 'ประวัติสุขภาพจิต',
      eHistory: 'ประวัติการจ้างงาน',
      currentEmployer: 'รายละเอียดนายจ้างปัจจุบัน',
      workPermits: 'ใบอนุญาตทำงานและสัญญาแรงงาน',
      certifications: 'ใบรับรองและใบอนุญาตวิชาชีพ',
      unemployment: 'สถานะการว่างงานและผลประโยชน์ที่ได้รับ',
      tin: 'หมายเลขประจำตัวผู้เสียภาษี (TIN)',
      businessAffiliations: 'การเป็นเจ้าของธุรกิจและการสังกัดบริษัท',
      schools: 'โรงเรียนและมหาวิทยาลัยที่เข้าเรียน',
      education: 'การศึกษา',
      degrees: 'ประกาศนียบัตร ปริญญา และใบรับรอง',
      performance: 'ผลการเรียนและคะแนนสอบ',
      academicRecords: "บันทึกวิชาการ",
      scholarships: 'ทุนการศึกษาและความช่วยเหลือทางการเงินที่ได้รับ',
      incomeTax: 'บันทึกภาษีเงินได้',
      bankAccounts: 'บัญชีธนาคารและการเงิน',
      propertyTax: 'การชำระภาษีทรัพย์สิน',
      businessTax: 'การยื่นภาษีธุรกิจ',
      pensionContrib: 'การบริจาคและการถอนบำนาญ',
      loanAid: 'บันทึกเงินกู้และความช่วยเหลือจากรัฐบาล',
      pensionStatus: 'สถานะบำนาญและการบริจาค',
      childcare: 'การสนับสนุนการดูแลเด็ก',
      foodAssistance: 'โปรแกรมความช่วยเหลือด้านอาหาร / สวัสดิการ',
      housingAssistance: 'ความช่วยเหลือด้านที่อยู่อาศัย',
      policeRecords: 'บันทึกตำรวจ (ประวัติอาชญากรรม การจับกุม การกล่าวหา)',
      courtCases: 'ประวัติคดีศาล',
      finesPenalties: 'ค่าปรับและบทลงโทษ',
      paroleProbation: 'สถานะการทัณฑ์บนหรือการคุมประพฤติ',
      citizenshipRevocation: 'การเพิกถอนสัญชาติ (ถ้ามี)',
      vehicleReg: 'รายละเอียดการจดทะเบียนยานพาหนะ',
      trafficViolations: 'การละเมิดกฎจราจรและค่าปรับ',
      licenseHistory: 'ประวัติใบขับขี่และการรับรอง',
      publicTransportCard: 'การใช้งานบัตรขนส่งสาธารณะ',
      voterRegistration: 'รายละเอียดการลงทะเบียนผู้มีสิทธิเลือกตั้ง',
      electionHistory: 'ประวัติการมีส่วนร่วมในการเลือกตั้ง',
      partyMembership: 'การเป็นสมาชิกพรรคการเมือง',
      militaryStatus: 'สถานะการรับราชการทหารหรือการเกณฑ์ทหาร',
      publicServiceRoles: 'บทบาทการบริการสาธารณะ'
    },
    placeholders: {
      fullName: 'ป้อนชื่อเต็มตามกฎหมายของคุณ',
      nationality: 'ป้อนสัญชาติของคุณ',
      searchCountries: 'ค้นหาประเทศ...',
      selectCountry: 'เลือกประเทศ',
      searchDisciplines: "ค้นหาสาขา...",
      selectDiscipline: "เลือกสาขา",
      searchDegrees: "ค้นหาปริญญา...",
      selectDegree: "เลือกปริญญา"
    },
    validation: {
      nameRequired: 'ต้องระบุชื่อเต็ม',
      dobRequired: 'ต้องระบุวันเกิด',
      dobFuture: 'วันเกิดไม่สามารถเป็นอนาคตได้',
      requiredField: '{field} จำเป็น',
      invalidFormat: 'รูปแบบไม่ถูกต้องสำหรับ {field}',
      futureDate: 'วันที่ไม่สามารถเป็นอนาคตได้',
      invalidSelection: 'โปรดเลือกที่ถูกต้อง',
      passwordLength: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร',
      matchError: 'ฟิลด์ไม่ตรงกัน'
    },
    errors: {
      savingFailed: 'ล้มเหลวในการบันทึกโปรไฟล์',
      loadingFailed: 'ล้มเหลวในการโหลดข้อมูลโปรไฟล์',
      invalidForm: 'โปรดกรอกฟิลด์ที่จำเป็นทั้งหมด',
      invalidFileType: 'ประเภทไฟล์ไม่ถูกต้อง',
      fileTooLarge: 'ไฟล์ใหญ่เกินไป',
      countryLoadError: 'ข้อผิดพลาดในการโหลดประเทศ',
      countryUpdateError: 'ข้อผิดพลาดในการอัปเดตประเทศ'
    },
    notifications: {
      saveSuccess: 'บันทึกโปรไฟล์สำเร็จ',
      saveFailed: 'ล้มเหลวในการบันทึกโปรไฟล์',
      loadSuccess: 'โหลดโปรไฟล์สำเร็จ',
      loadFailed: 'ล้มเหลวในการโหลดโปรไฟล์',
      fieldRequired: 'ฟิลด์นี้จำเป็น',
      uploadSuccess: 'อัปโหลดไฟล์สำเร็จ',
      uploadFailed: 'ล้มเหลวในการอัปโหลดไฟล์',
      formChanged: 'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก',
      sessionExpired: 'เซสชันของคุณหมดอายุ โปรดเข้าสู่ระบบอีกครั้ง',
      profileUpdated: 'โปรไฟล์ของคุณได้รับการอัปเดต',
      profileIncomplete: 'โปรไฟล์ของคุณไม่สมบูรณ์'
    },
    instructions: {
      fullNameHelp: 'ป้อนชื่อเต็มตามกฎหมายของคุณตามที่ปรากฏในเอกสารอย่างเป็นทางการ',
      dobHelp: 'ป้อนวันเกิดของคุณในรูปแบบ MM/DD/YYYY',
      uploadPhotoHelp: 'อัปโหลดรูปภาพล่าสุด ไฟล์ต้องเป็น JPG, PNG หรือ GIF และน้อยกว่า 2MB',
      passwordHelp: 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษรพร้อมตัวอักษรตัวใหญ่หนึ่งตัว ตัวเลขหนึ่งตัว และตัวอักษรพิเศษหนึ่งตัว',
      documentHelp: 'รูปแบบที่ยอมรับ: PDF, JPG, PNG (สูงสุด 5MB)',
      requiredFields: 'ฟิลด์ที่ทำเครื่องหมายด้วย * จำเป็น',
      selectFromList: 'โปรดเลือกตัวเลือกจากรายการ',
      nextTab: 'ดำเนินการต่อไปยังส่วนถัดไป',
      previousTab: 'กลับไปยังส่วนก่อนหน้า',
      saveInstructions: 'คลิกบันทึกเพื่อเก็บข้อมูลของคุณ',
      cancelInstructions: 'คลิกยกเลิกเพื่อยกเลิกการเปลี่ยนแปลง'
    },
    completionStatus: {
      notStarted: 'ยังไม่ได้เริ่ม',
      inProgress: 'กำลังดำเนินการ',
      complete: 'เสร็จสิ้น',
      percentComplete: '{percent}% เสร็จสิ้น',
      tabsCompleted: '{completed} จาก {total} ส่วนเสร็จสิ้น',
      tabComplete: 'แท็บเสร็จสิ้น!'
    },
    gender: {
      male: 'ชาย',
      female: 'หญิง',
      other: 'อื่นๆ',
      preferNot: 'ไม่ต้องการระบุ'
    },
    maritalStatus: {
      single: 'โสด',
      married: 'แต่งงาน',
      divorced: 'หย่า',
      widowed: 'หม้าย',
      other: 'อื่นๆ'
    },
    residencyStatuses: {
      citizen: 'พลเมือง',
      permanentResident: 'ผู้อยู่อาศัยถาวร',
      temporaryResident: 'ผู้อยู่อาศัยชั่วคราว',
      other: 'อื่นๆ'
    },
    employmentStatuses: {
      employed: 'จ้างงาน',
      selfEmployed: 'ประกอบอาชีพอิสระ',
      unemployed: 'ว่างงาน',
      student: 'นักศึกษา',
      retired: 'เกษียณ',
      homemaker: 'แม่บ้าน',
      other: 'อื่นๆ'
    },
    educationLevels: {
      primary: 'การศึกษาประถม',
      secondary: 'การศึกษามัธยม',
      highSchool: 'มัธยมปลาย',
      vocational: 'การฝึกอาชีพ',
      associate: 'อนุปริญญา',
      bachelor: 'ปริญญาตรี',
      master: 'ปริญญาโท',
      doctoral: 'ปริญญาเอก',
      professional: 'ปริญญาวิชาชีพ',
      other: 'อื่นๆ'
    },
    proficiencyLevels: {
      native: 'เจ้าของภาษา',
      fluent: 'คล่องแคล่ว',
      advanced: 'ขั้นสูง',
      intermediate: 'ระดับกลาง',
      basic: 'พื้นฐาน'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'ไม่ทราบ'
    },
    languages: {
      english: 'อังกฤษ',
      french: 'ฝรั่งเศส',
      swahili: 'สวาฮิลี',
      arabic: 'อาหรับ',
      spanish: 'สเปน',
      portuguese: 'โปรตุเกส',
      chinese: 'จีน',
      japanese: 'ญี่ปุ่น',
      german: 'เยอรมัน',
      russian: 'รัสเซีย',
      hindi: 'ฮินดี',
      urdu: 'อูรดู',
      other: 'อื่นๆ'
    },
    yesNo: {
      yes: 'ใช่',
      no: 'ไม่'
    },
    select: 'โปรดเลือก',
    existingFile: 'ไฟล์ที่มีอยู่',
    noMatchingCountries: 'ไม่พบประเทศที่ตรงกัน',
    noMatchingDisciplines: "ไม่พบสาขาที่ตรงกัน",
    noMatchingDegrees: "ไม่พบปริญญาที่ตรงกัน",
    educationOptions: [
      "บัญชี", "วิศวกรรมการบินและอวกาศ", "วิทยาศาสตร์การเกษตร", "มานุษยวิทยา", "สถาปัตยกรรม",
      "ประวัติศาสตร์ศิลปะ", "ปัญญาประดิษฐ์", "ดาราศาสตร์", "ฟิสิกส์ดาราศาสตร์", "ชีวเคมี",
      "วิศวกรรมชีวการแพทย์", "เทคโนโลยีชีวภาพ", "บริหารธุรกิจ", "วิศวกรรมเคมี",
      "เคมี", "วิศวกรรมโยธา", "การสื่อสาร", "วิศวกรรมคอมพิวเตอร์", "วิทยาการคอมพิวเตอร์",
      "การจัดการก่อสร้าง", "กระบวนการยุติธรรมอาญา", "ความปลอดภัยทางไซเบอร์", "วิทยาศาสตร์ข้อมูล", "ทันตกรรม",
      "เศรษฐศาสตร์", "การศึกษา", "วิศวกรรมไฟฟ้า", "การศึกษาปฐมวัย", "วรรณคดีอังกฤษ",
      "วิศวกรรมสิ่งแวดล้อม", "วิทยาศาสตร์สิ่งแวดล้อม", "การออกแบบแฟชั่น", "การศึกษาภาพยนตร์",
      "การเงิน", "ศิลปกรรม", "วิทยาศาสตร์อาหาร", "วิทยาศาสตร์นิติวิทยาศาสตร์", "การออกแบบเกม",
      "ภูมิศาสตร์", "ธรณีวิทยา", "การออกแบบกราฟิก", "การบริหารสุขภาพ", "ประวัติศาสตร์",
      "การจัดการการโรงแรม", "ทรัพยากรมนุษย์", "การออกแบบอุตสาหกรรม", "วิศวกรรมอุตสาหกรรม", "ระบบสารสนเทศ",
      "เทคโนโลยีสารสนเทศ", "การออกแบบภายใน", "ธุรกิจระหว่างประเทศ", "ความสัมพันธ์ระหว่างประเทศ",
      "วารสารศาสตร์", "กฎหมาย", "บรรณารักษศาสตร์", "ภาษาศาสตร์", "การจัดการ", "การตลาด",
      "วิทยาศาสตร์วัสดุ", "คณิตศาสตร์", "วิศวกรรมเครื่องกล", "การศึกษาสื่อ", "แพทยศาสตร์",
      "อุตุนิยมวิทยา", "จุลชีววิทยา", "ดนตรี", "เทคโนโลยีนาโน", "พยาบาล", "โภชนาการ",
      "อาชีวบำบัด", "สมุทรศาสตร์", "วิศวกรรมปิโตรเลียม", "เภสัชศาสตร์", "ปรัชญา",
      "การถ่ายภาพ", "พลศึกษา", "กายภาพบำบัด", "ฟิสิกส์", "รัฐศาสตร์",
      "จิตวิทยา", "การบริหารรัฐกิจ", "สาธารณสุข", "ประชาสัมพันธ์", "หุ่นยนต์",
      "การศึกษามัธยม", "งานสังคมสงเคราะห์", "สังคมวิทยา", "วิศวกรรมซอฟต์แวร์", "การศึกษาพิเศษ",
      "การจัดการกีฬา", "สถิติ", "วิศวกรรมระบบ", "ศิลปะการละคร", "การท่องเที่ยว",
      "การวางผังเมือง", "สัตวแพทยศาสตร์", "การพัฒนาเว็บ", "ชีววิทยาสัตว์ป่า", "สัตววิทยา"
    ],
    degreeOptions: [
      "อนุปริญญา", "ศิลปศาสตรบัณฑิต (BA)", "วิทยาศาสตรบัณฑิต (BS)", "วิศวกรรมศาสตรบัณฑิต (BEng)",
      "บริหารธุรกิจบัณฑิต (BBA)", "ศิลปกรรมศาสตรบัณฑิต (BFA)", "ศึกษาศาสตรบัณฑิต (BEd)",
      "แพทยศาสตรบัณฑิต (MBBS)", "นิติศาสตรบัณฑิต (LLB)", "ศิลปศาสตรมหาบัณฑิต (MA)", "วิทยาศาสตรมหาบัณฑิต (MS)",
      "บริหารธุรกิจมหาบัณฑิต (MBA)", "วิศวกรรมศาสตรมหาบัณฑิต (MEng)", "ศิลปกรรมศาสตรมหาบัณฑิต (MFA)",
      "ศึกษาศาสตรมหาบัณฑิต (MEd)", "นิติศาสตรมหาบัณฑิต (LLM)", "สาธารณสุขศาสตรมหาบัณฑิต (MPH)",
      "ปรัชญาดุษฎีบัณฑิต (PhD)", "แพทยศาสตรดุษฎีบัณฑิต (MD)", "ศึกษาศาสตร์ดุษฎีบัณฑิต (EdD)",
      "บริหารธุรกิจดุษฎีบัณฑิต (DBA)", "นิติศาสตร์ดุษฎีบัณฑิต (JD)", "ประกาศนียบัตรวิชาชีพ",
      "ประกาศนียบัตรเทคนิค", "ประกาศนียบัตรอาชีวะ", "ประกาศนียบัตรบัณฑิต", "อนุปริญญาบัณฑิต", "หลังปริญญาเอก"
    ],
    aria: {
      tabList: 'ส่วนฟอร์มโปรไฟล์',
      nextButton: 'ไปยังส่วนถัดไป',
      prevButton: 'ไปยังส่วนก่อนหน้า',
      closeButton: 'ปิดฟอร์มโปรไฟล์',
      saveButton: 'บันทึกข้อมูลโปรไฟล์',
      requiredField: 'ฟิลด์ที่จำเป็น',
      dropdownSelect: 'เลือกตัวเลือก'
    }
  },
  chatbot: {
    placeholder: 'พิมพ์คำถามของคุณที่นี่...',
    sendButton: 'ส่ง',
    fileReceived: 'ได้รับไฟล์สำเร็จ',
    fileUploadError: 'ข้อผิดพลาดในการอัปโหลดไฟล์',
    processingError: 'ข้อผิดพลาดในการประมวลผลคำขอของคุณ',
    welcomeMessage: 'ยินดีต้อนรับ! ฉันสามารถช่วยเหลือคุณเกี่ยวกับบริการรัฐบาลเคนยาได้อย่างไรวันนี้?',
    attachFile: 'แนบไฟล์',
    fileTooLarge: 'ไฟล์ใหญ่เกินไป ขนาดสูงสุดคือ {maxSize}',
    saveChat: 'บันทึกแชท',
    chatSaved: 'บันทึกแชทแล้ว',
    chatTitle: 'ชื่อแชท',
    chatTitlePlaceholder: 'ป้อนชื่อสำหรับแชทนี้',
    selectFolder: 'เลือกโฟลเดอร์',
    newChat: 'แชทใหม่',
    clearContext: 'ล้างบริบทและเริ่มการสนทนาใหม่',
    unsavedChanges: 'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณแน่ใจว่าต้องการเริ่มแชทใหม่หรือไม่?',
    whatCanIHelp: "ฉันสามารถช่วยอะไรคุณได้วันนี้?",
    justChat: "แค่แชท",
    queryContext: "บริบทคำถาม",
    contextAdded: 'เพิ่มบริบทในคำถามของคุณ',
    contextRemoved: 'ลบบริบทจากคำถามของคุณ',
    sessionUpdated: 'อัปเดตเซสชัน',
    newChatStarted: 'เริ่มการสนทนาใหม่',
    loadError: 'ไม่สามารถโหลดประวัติแชทได้',
    responsePrefix: "ฉันได้รับข้อความของคุณ",
    withContext: "พร้อมบริบท",
    conversationLoaded: "โหลดการสนทนาสำเร็จ!",
    saveConfirmTitle: "บันทึกการสนทนาที่มีอยู่",
    saveConfirmMessage: "บันทึกการสนทนาที่มีอยู่?",
    loadConfirmTitle: "โหลดการสนทนาที่มีอยู่",
    loadConfirmMessage: "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณต้องการยกเลิกและโหลดการสนทนาที่เลือก หรือบันทึกการสนทนาปัจจุบันก่อน?",
    loadAndDiscard: "โหลดและยกเลิก",
    saveAndLoad: "บันทึกและโหลด",
    saveAndStartNew: "บันทึกและเริ่มใหม่",
    discardAndStartNew: "ยกเลิกและเริ่มใหม่",
    newChatTitle: "เริ่มแชทใหม่",
    exportChat: 'ส่งออกแชท',
    exportFilename: 'ชื่อไฟล์',
    exportFilenamePlaceholder: 'ป้อนชื่อไฟล์',
    exportButton: 'ส่งออก',
    exportSuccess: 'ส่งออกแชทสำเร็จ',
    exportError: 'ล้มเหลวในการส่งออกแชท โปรดลองอีกครั้ง'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "สมัครบัตรประชาชน",
    payTaxes: "ชำระภาษี",
    startBusiness: "เริ่มธุรกิจ",
    findHealthcare: "สุขภาพ",
    educationServices: "การศึกษา",
    transportLicenses: "การขนส่ง",
    housingPrograms: "ที่อยู่อาศัย",
    findJobs: "งาน",
    justChat: "แชทเท่านั้น",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "ฉันอยากแชทเกี่ยวกับบริการรัฐบาล",
    applyForIDUserPrompt: "ฉันต้องการข้อมูลเกี่ยวกับวิธีสมัครบัตรประชาชนแห่งชาติ",
    payTaxesUserPrompt: "กระบวนการชำระภาษีออนไลน์คืออะไร?",
    startBusinessUserPrompt: "นำฉันผ่านขั้นตอนการจดทะเบียนธุรกิจใหม่",
    findHealthcareUserPrompt: "ฉันสามารถหาข้อมูลเกี่ยวกับบริการสุขภาพสาธารณะได้ที่ไหน?",
    educationServicesUserPrompt: "บริการการศึกษาอะไรที่มีสำหรับลูกของฉัน?",
    transportLicensesUserPrompt: "ฉันจะต่ออายุใบขับขี่อย่างไร?",
    housingProgramsUserPrompt: "บอกฉันเกี่ยวกับโปรแกรมที่อยู่อาศัยราคาไม่แพงในเคนยา",
    findJobsUserPrompt: "โอกาสงานรัฐบาลอะไรที่มีอยู่ในปัจจุบัน?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "Act as a helpful Kenyan civil registration expert. Explain the steps for obtaining a National ID (Maisha Namba) or replacing a lost one. IMPORTANT: Provide a clear list of required documents (e.g., Birth Certificate, copies of parents' IDs) and advise the user to visit their nearest Huduma Centre or Registrar of Persons office. RULE: Always refer to the application as 'Genie AI'.",

    payTaxesPrompt: "Act as a KRA (Kenya Revenue Authority) guide. Explain the process of filing returns, applying for a KRA PIN, or resetting a password on the iTax portal. IMPORTANT: Remind the user of the June 30th deadline for annual returns and guide them on how to file Nil returns if they had no income. RULE: Always refer to the application as 'Genie AI'.",

    startBusinessPrompt: "Act as a business consultant for eCitizen services. Guide the user through business name reservation and company registration in Kenya. IMPORTANT: Explain the current costs for name search and registration, and direct the user to the official eCitizen portal to complete the application. RULE: Always refer to the application as 'Genie AI'.",

    findHealthcarePrompt: "Act as a health services navigator. Provide information on the transition from NHIF to SHIF (Social Health Insurance Fund) and how to register. IMPORTANT: Share the official USSD codes (like *263#) or website links for registration and explain the benefits of the public health cover. RULE: Always refer to the application as 'Genie AI'.",

    educationServicesPrompt: "Act as an education counselor. Discuss the CBC curriculum, NEMIS registration, or university placement via KUCCPS. IMPORTANT: Explain how parents can check national exam results via SMS or the KNEC portal when released. RULE: Always refer to the application as 'Genie AI'.",

    transportLicensesPrompt: "Act as an NTSA service guide. Explain the process for driving license renewal, vehicle inspection, or TIMS account management. IMPORTANT: Guide the user on how to log in to the eCitizen NTSA portal to apply for their Smart DL or book a vehicle inspection. RULE: Always refer to the application as 'Genie AI'.",

    housingProgramsPrompt: "Act as a housing program advisor. Explain the Affordable Housing Program (Boma Yangu) registration and voluntary contribution process. IMPORTANT: Guide the user to the Boma Yangu portal to view projects and explain the eligibility criteria for allocation. RULE: Always refer to the application as 'Genie AI'.",

    findJobsPrompt: "Act as a career coach for the public service. Guide the user on creating a profile and applying for vacancies via the Public Service Commission (PSC) portal. IMPORTANT: Advise the user to keep their academic certificates ready and to regularly check the PSC website or local dailies for MyGov advertisements. RULE: Always refer to the application as 'Genie AI'.",

    justChatPrompt: "Act as a friendly local companion. Be polite, helpful, and knowledgeable about Kenyan culture and daily life. IMPORTANT: Remind the user that while you can chat about anything, your main strength is helping them navigate Kenyan government services like **IDs**, **Taxes**, and **Business Registration**. RULE: Always refer to the application as 'Genie AI'."
  },
  common: {
    cancel: 'ยกเลิก',
    create: 'สร้าง',
    save: 'บันทึก',
    move: 'ย้าย',
    delete: 'ลบ',
    // --- NEW KEYS ADDED ---
    ok: 'ตกลง',
    ingest: 'นำเข้าข้อมูล',
    retract: 'ดึงกลับ',
    loading: 'กำลังโหลด...',
    refresh: 'รีเฟรช'
  },
  feedback: {
    title: 'ความคิดเห็น',
    button: 'ความคิดเห็น',
    positive: 'ความคิดเห็นเชิงบวก',
    negative: 'ความคิดเห็นเชิงลบ',
    promptText: 'คำตอบนี้มีประโยชน์หรือไม่?',
    placeholder: 'ความคิดเห็นเพิ่มเติม...',
    submit: 'ส่งความคิดเห็น',
    close: 'ยกเลิก',
    thankYouMessage: 'ขอบคุณสำหรับความคิดเห็นของคุณ!',
    submitting: 'กำลังส่ง...',
    error: 'เกิดข้อผิดพลาด โปรดลองอีกครั้ง',
    success: 'ขอบคุณสำหรับความคิดเห็นของคุณ!'
  },
  responseRating: {
    title: 'ช่วยเราปรับปรุง',
    note: 'ความคิดเห็นของคุณจะถูกใช้เพื่อปรับแต่งแชทบอทและปรับปรุงคำตอบตามเวลา',
    chatbotResponse: 'คำตอบแชทบอท:',
    ratingLabels: {
      1: 'ไร้ประโยชน์',
      2: 'มีประโยชน์เล็กน้อย',
      3: 'มีประโยชน์ปานกลาง',
      4: 'มีประโยชน์มาก',
      5: 'เปลี่ยนชีวิต'
    },
    additionalComments: 'ความคิดเห็นเพิ่มเติม...',
    submit: 'ส่ง',
    cancel: 'ยกเลิก'
  },
  upload: {
    alt: 'อัปโหลด'
  },
  details: {
    loading: 'กำลังโหลดรายละเอียดไฟล์...',
    title: 'รายละเอียดไฟล์',
    close: 'ปิด',
    fileName: 'ชื่อไฟล์',
    author: 'ผู้เขียน',
    labels: 'ป้ายกำกับ',
    selectAll: 'เลือกทั้งหมด',
    loadingLabels: 'กำลังโหลดป้ายกำกับ...',
    status: 'สถานะ',
    fileId: 'รหัสไฟล์',
    fileType: 'ประเภทไฟล์',
    viewFile: 'ดูไฟล์',
    visitLink: 'เยี่ยมชมลิงก์ภายนอก',
    openFile: 'เปิดไฟล์ในแท็บใหม่',
    fileSize: 'ขนาดไฟล์',
    uploadDate: 'วันที่อัปโหลด',
    hash: 'SHA256 แฮช',
    // --- NEW: TABS ---
    tabs: {
      details: "รายละเอียด",
      ingestionLog: "บันทึกการนำเข้าข้อมูล"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "การดำเนินการหยุด:",
      killDocument: "หยุดเอกสารนี้",
      killProcess: "หยุดกระบวนการนำเข้าข้อมูล",
      timestamp: "เวลา",
      level: "ระดับ",
      stage: "ขั้นตอน",
      message: "ข้อความ",
      loadingLogs: "กำลังโหลดบันทึก...",
      noLogs: "ไม่พบบันทึก"
    },
    buttons: {
      saveMetadata: 'บันทึกข้อมูลเมตา',
      retract: 'ดึงกลับ',
      ingest: 'นำเข้าข้อมูล'
    },
    notifications: {
      loadError: 'ไม่สามารถโหลดรายละเอียดไฟล์ได้',
      validationError: 'จำเป็นต้องกรอกชื่อไฟล์และผู้เขียน',
      saveSuccess: 'อัปเดตข้อมูลเมตาเรียบร้อยแล้ว',
      saveError: 'ไม่สามารถบันทึกข้อมูลเมตาได้',
      tokenError: 'ไม่พบโทเค็นการยืนยันตัวตนในข้อมูลผู้ใช้',
      viewError: 'ไม่สามารถโหลดไฟล์เพื่อดูได้',
      ingestSuccess: 'ไฟล์ถูกจัดคิวเพื่อนำเข้าข้อมูลเรียบร้อยแล้ว',
      ingestError: 'ไม่สามารถเริ่มกระบวนการนำเข้าข้อมูลได้',
      retractSuccess: 'ไฟล์ถูกดึงกลับเรียบร้อยแล้ว',
      retractError: 'ไม่สามารถดึงกลับไฟล์ได้',
      deleteSuccess: 'ลบไฟล์เรียบร้อยแล้ว',
      deleteError: 'ไม่สามารถลบไฟล์ได้',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "โปรดเลือกอย่างน้อยหนึ่งป้ายกำกับก่อนนำเข้าข้อมูล",
      ingestSaving: "กำลังบันทึกข้อมูลเมตาก่อนนำเข้าข้อมูล...",
      ingestSaveFailed: "ไม่สามารถบันทึกข้อมูลเมตาได้ ยกเลิกการนำเข้าข้อมูล",
      logError: "ไม่สามารถดึงบันทึกการนำเข้าข้อมูลได้",
      killDocSent: "ส่งคำขอหยุดสำหรับเอกสารนี้แล้ว",
      killProcSent: "ส่งคำขอหยุดสำหรับกระบวนการนำเข้าข้อมูลแล้ว"
    },
    confirm: {
      ingest: 'คุณแน่ใจหรือไม่ว่าต้องการนำเข้าไฟล์นี้? นี่จะเป็นการเริ่มกระบวนการประมวลผลข้อมูล',
      retract: 'คุณแน่ใจหรือไม่ว่าต้องการดึงกลับไฟล์นี้?',
      delete: 'คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์นี้อย่างถาวร? การกระทำนี้ไม่สามารถยกเลิกได้',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "ยืนยันการนำเข้าข้อมูล",
      retractTitle: "ยืนยันการดึงกลับ",
      deleteTitle: "ยืนยันการลบ",
      killDocTitle: "หยุดการนำเข้าข้อมูลเอกสาร",
      killDoc: "คุณแน่ใจหรือไม่ว่าต้องการหยุดงานนำเข้าข้อมูลสำหรับเอกสารนี้? ระบบจะพยายามย้อนกลับอย่างปลอดภัย",
      killProcTitle: "หยุดกระบวนการนำเข้าข้อมูลทั้งหมด",
      killProc: "คำเตือน: นี่จะเป็นการหยุดบริการนำเข้าข้อมูลแบ็กเอนด์ทั้งหมด ซึ่งส่งผลกระทบต่อไฟล์ทั้งหมดที่กำลังประมวลผลอยู่ คุณแน่ใจหรือไม่?"
    }
  },
  uploadDialog: {
    title: 'อัปโหลดไฟล์',
    dropzone: 'ลากและวางไฟล์ที่นี่ หรือคลิกเพื่อเลือก',
    allowedTypesLabel: 'ประเภทที่อนุญาต:',
    buttonUpload: 'อัปโหลด {count} ไฟล์', // Pluralization might need adjustment
    remove: 'ลบ',
    uploading: 'กำลังอัปโหลด...',
    notifications: {
      dropError: 'สามารถวางไฟล์ได้เท่านั้น โปรดตรวจสอบว่าคุณกำลังลากไฟล์ที่ถูกต้องจากคอมพิวเตอร์ของคุณ',
      typeNotAllowed: 'ประเภทไฟล์ "{extension}" ไม่ได้รับอนุญาต',
      shortcutUnsupported: 'ไฟล์ทางลัด (.url) ไม่รองรับ โปรดลากไฟล์จริง',
      duplicate: 'ไฟล์ "{fileName}" ถูกเพิ่มแล้ว',
      uploadSuccess: 'อัปโหลด {fileName} สำเร็จ',
      uploadFailed: 'ล้มเหลวในการอัปโหลด {fileName}'
    }
  }
}